import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'start_finish_times_payroll_system_do_not_match'

export const dataPointDefinition = {
  retracedId: 'start_finish_times_payroll_system_do_not_match',
  name: 'Start and finish times in the payroll system do not match exact time in/out in time records',
  description:
    'The intent of this question is to understand if a worker�s start and finish times in payroll match the start and finish times logged in attendance records. ',
  meta: {
    slcpMeta: {
      key: 'wh-wor-25x',
      number: 'WH-WOR-4-4',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wh-wor-25x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36540,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
